import { connect } from "react-redux";
// import { useHistory } from "react-router-dom";
import { Layout } from "antd";
import { logout } from "../../redux/user/user.actions";
import Header from "../../components/Header";
import SellerSideNav from "../seller/SellerSideNav";
const { Content } = Layout;

const Dashboard = ({
  currentPageKey,
  children,
  headerTitle,
  headerSubtitle,
  dashboardBgColor,
  noSideNav,
}) => {
  // const history = useHistory();

  return (
    <div className="seller-layout-dashboard">
      <Header headerTitle={headerTitle} headerSubtitle={headerSubtitle} />
      <Layout>
        <div style={{ display: noSideNav ? "none" : "block" }}>
          <SellerSideNav currentPageKey={currentPageKey} />
        </div>

        <Layout
          className="site-layout"
          style={{ marginLeft: noSideNav ? "0px" : "240px", marginTop: "60px" }}
        >
          {/* <Header search={true} right={50} top={20} /> */}

          <Content>
            <div
              className="site-layout-background"
              style={{ padding: "24px 40px" }}
            >
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>

      <style jsx="true">{`
        .logo-div {
          margin: 35px;
        }
        .logo {
          width: 150px;
        }
        .site-layout .site-layout-background {
          background: ${dashboardBgColor || "#fff"}; 
          min-height: calc(100vh - 66px);
        }
        .seller-layout-dashboard .ant-layout-header {
          line-height: normal;
        }
      `}</style>
    </div>
  );
};

const matchDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, matchDispatchToProps)(Dashboard);
